@if (isOpen) {
<div class="wide">
  <div class="nav-links p-3">
    @if(sidebarData$ | async; as sidebarData) {
    @for(group of sidebarData.groups; track group.name) {
    <div class="nav-group">
      <button class="nav-group-header" (click)="toggleGroup(group.name)">
        <i class="bi me-1" [class.bi-chevron-right]="!expandedGroups[group.name]"
          [class.bi-chevron-down]="expandedGroups[group.name]"></i>
        @if(group.name === 'Favorites') {
        <i class="bi bi-star-fill me-1 text-warning"></i>
        }
        <span>{{ group.name }}</span>
      </button>
      @if(expandedGroups[group.name]) {
      <div class="nav-group-items">
        @for(mod of group.modules; track mod.name) {
        <a [routerLink]="mod.route" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ mod.translationKey | translate }}</span>
        </a>
        }
      </div>
      }
    </div>
    }
    }

    @if(!isElectron) {
    <div class="nav-group">
      <button class="nav-group-header" (click)="toggleGroup('others')">
        <i class="bi me-1" [class.bi-chevron-right]="!expandedGroups['others']"
          [class.bi-chevron-down]="expandedGroups['others']"></i>
        <span>{{ 'APP.OTHERS' | translate }}</span>
      </button>
      @if(expandedGroups['others']) {
      <div class="nav-group-items">


        @if(canUserManagement$ | async) {
        <a routerLink="/user-settings/list" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.USER_MANAGEMENT' | translate }}</span>
        </a>
        }


        @if(_simulationService.isSimulationMode) {
        <a routerLink="/simulation/list" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.SIMULATION' | translate }}</span>
        </a>
        }

        @if(_simulationService.isSimulationMode && _simulationService.workPackageId) {
        <a routerLink="/data-change/list" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.DATA_CHANGE' | translate }}</span>
        </a>
        }

        @if(!_simulationService.isSimulationMode && _companyFeService.selectedUserCompanyId && (canProject$ | async)) {
        <a routerLink="/project/list" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.PROJECT' | translate }}</span>
        </a>
        }

        @if(!_simulationService.isSimulationMode && _companyFeService.selectedUserCompanyId && (canProject$ | async)) {
        <a routerLink="/project-calculation/list" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.PROJECT_CALCULATION' | translate }}</span>
        </a>
        }

        @if(!_simulationService.isSimulationMode && _companyFeService.selectedUserCompanyId) {
        <a routerLink="/recent-calculations" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-text me-1"></i>
          <span>{{ 'APP.RECENT_CALCULATIONS' | translate }}</span>
        </a>
        }

      </div>
      }
    </div>
    }

    @if(!isElectron && _companyFeService.selectedUserCompanyId) {
    <a routerLink="/modules/list" routerLinkActive="active" class="nav-link">
      <i class="bi bi-grid me-1"></i>
      <span>{{ 'APP.MODULES' | translate }}</span>
    </a>
    }
  </div>
  <div class="arrow" ngbTooltip="{{ 'CONTROLS.COLLAPSE' | translate }}" (click)="onToggle()" (keypress)="onToggle()"
    tabindex="0">
    <i class="bi bi-chevron-left"></i>
  </div>
</div>
<div class="sidebar-version" *ngIf="version">
  Version: {{ version }}
</div>
} @else {
<div class="narrow">
  <div class="nav-links">
    @if(sidebarData$ | async; as sidebarData) {
    @for(group of sidebarData.groups; track group.name) {
    <div class="nav-group-narrow">
      <button class="nav-group-header-narrow" (click)="toggleGroup(group.name)">
        @if(group.name === 'Favorites') {
        <i class="bi bi-star-fill text-warning" [ngbTooltip]="group.name"></i>
        } @else {
        <i class="bi bi-tools" [ngbTooltip]="group.name"></i>
        }
      </button>
      @if(expandedGroups[group.name]) {
      @for(mod of group.modules; track mod.name) {
      <a [routerLink]="mod.route" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="mod.translationKey | translate"></i>
      </a>
      }
      }
    </div>
    }
    }

    @if(!isElectron) {
    <div class="nav-group-narrow">
      <button class="nav-group-header-narrow" (click)="toggleGroup('others')">
        <i class="bi bi-gear" [ngbTooltip]="'APP.OTHERS' | translate"></i>
      </button>
      @if(expandedGroups['others']) {

      @if(canUserManagement$ | async) {
      <a routerLink="/user-settings/list" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="'APP.USER_MANAGEMENT' | translate"></i>
      </a>
      }

      @if(_simulationService.isSimulationMode) {
      <a routerLink="/simulation/list" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="'APP.SIMULATION' | translate"></i>
      </a>
      }

      @if(_simulationService.isSimulationMode && _simulationService.workPackageId) {
      <a routerLink="/data-change/list" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="'APP.DATA_CHANGE' | translate"></i>
      </a>
      }

      @if(!_simulationService.isSimulationMode && _companyFeService.selectedUserCompanyId) {
      <a routerLink="/project/list" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="'APP.PROJECT' | translate"></i>
      </a>
      }

      @if(!_simulationService.isSimulationMode && _companyFeService.selectedUserCompanyId) {
      <a routerLink="/project-calculation/list" routerLinkActive="active" class="nav-link">
        <i class="bi bi-file-text me-1" [ngbTooltip]="'APP.PROJECT_CALCULATION' | translate"></i>
      </a>
      }

      }
    </div>
    }

    @if(!isElectron && _companyFeService.selectedUserCompanyId) {
    <a routerLink="/modules/list" routerLinkActive="active" class="nav-link">
      <i class="bi bi-grid me-1" [ngbTooltip]="'APP.MODULES' | translate"></i>
    </a>
    }
  </div>
  <div class="arrow" ngbTooltip="{{ 'CONTROLS.EXPAND' | translate }}" (click)="onToggle()" (keypress)="onToggle()"
    tabindex="0">
    <i class="bi bi-chevron-right"></i>
  </div>
</div>
<div class="sidebar-version" *ngIf="version">
  <i class="bi bi-info-circle me-1" [ngbTooltip]="'Version: ' + version"></i>
</div>
}